import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import './Footer.scss';
import { navItems } from 'model/app.json';
import { setNavMethodForGTM } from 'redux/actions';

const Footer = (props) => {
    const lastLink = {
        href: '/',
        navLink: 'Start from the beginning'
    }
    const prevPage = navItems[props.pageIndex - 1];
    const nextPage = navItems[props.pageIndex + 1] || lastLink;
    
    return (
        <footer className="footer">
            <Link to={prevPage.href} onClick={() => props.setNavMethodForGTM('Previous')} className="footer__link footer__link--left" title="Previous page">
                <div className="footer__btn footer__btn--left">
                    <span className="footer__btn-text">{prevPage.navLink}</span>
                </div>
            </Link>

            <Link to={nextPage.href} onClick={() => props.setNavMethodForGTM('Next')} className="footer__link footer__link--right" title="Next page">
                <div className="footer__btn footer__btn--right">
                    <span className="footer__btn-text">{nextPage.navLink}</span>
                </div>
                
            </Link>
        </footer>
    )
}

Footer.propTypes = {
    pageIndex: PropTypes.number.isRequired,
    setNavMethodForGTM: PropTypes.func
}

const mapDispatchToProps = (dispatch) => {
  return {
    setNavMethodForGTM: (method) => dispatch(setNavMethodForGTM(method))
  }
}

export default connect(null, mapDispatchToProps)(Footer)
